/**
 * @file
 * @author dailin01
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { cloneElement } from '../_util/reactNode';
import RcMenu from './rc-menu';
import useItems from './hooks/useItems';
const BaseMenu = props => {
    const { 
    // Menu本身配置
    prefixCls: customizePrefixCls, className, mode = 'horizontal', inlineCollapsed, expandIcon, iconList = [], scope, items, children } = props, rest = __rest(props, ["prefixCls", "className", "mode", "inlineCollapsed", "expandIcon", "iconList", "scope", "items", "children"]);
    const mergedChildren = useItems(items) || children;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('menu', customizePrefixCls);
    const menuClassName = classNames(className, {
        [`${prefixCls}-with-icon`]: mode === 'horizontal' && iconList.length,
        [`${prefixCls}-${scope}`]: scope
    });
    return (<RcMenu prefixCls={prefixCls} className={menuClassName} expandIcon={cloneElement(expandIcon, {
            className: `${prefixCls}-submenu-expand-icon`
        })} inlineCollapsed={inlineCollapsed} mode={mode} {...rest}>
            {mergedChildren}
        </RcMenu>);
};
export default BaseMenu;
